var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRss(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40.314,
    viewBox: "0 0 40 40.314",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6 -5.9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.736,39.268A5.368,5.368,0,1,1,11.368,33.9a5.391,5.391,0,0,1,5.368,5.368",
    transform: "translate(0 1.473)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,18.8v7.473S24,26.8,24.631,45.431h7.894S33.473,20.063,6,18.8",
    transform: "translate(0 0.678)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,5.9v7.579s29.367-.421,32.631,32.736H46c0-.105.842-38.1-40-40.314"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRss);
export default __webpack_public_path__ + "static/media/icon-rss.02120512.svg";
export { ForwardRef as ReactComponent };